import { useContext, useMemo } from 'react'
import { useHistory } from 'react-router-dom'

import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'

import { CreateGiftCard as request } from '../../network/GiftCards'
import { GiftCard } from '../../constants/forms/GiftCard'
import { AppContext } from '../../context/AppContext'

const CreateGiftCard = ({ history: historyProp }) => {
    const { user } = useContext(AppContext)
    const routerHistory = useHistory()
    const history = historyProp || routerHistory
    const customer = history?.location?.customer

    const formTemplate = useMemo(() => {
        if (!customer) return GiftCard

        return {
            ...GiftCard,
            sections: GiftCard.sections.map((section) => ({
                ...section,
                fields: section.fields.map((field) =>
                    field.key?.[0] === 'customer'
                        ? { ...field, isInactive: true }
                        : field
                ),
            })),
        }
    }, [customer])

    const returnToCustomer = () => {
        history.push({
            pathname: `/customers/${customer.id}`,
            defaultTab: 'gift-cards',
        })
    }

    return (
        <PageWrap goBack title="GIFT_CARDS_CREATE">
            <FormWrap
                title="create_gift_card"
                request={request}
                onSuccess={customer ? undefined : '/gift-cards'}
                onCancel={
                    customer ? `/customers/${customer.id}` : '/gift-cards'
                }
                beforeOnSuccess={
                    customer ? returnToCustomer : undefined
                }
                data={{
                    type: 'manual',
                    status: 'validated',
                    grantedByName: user.name,
                    customer: customer?.id,
                }}
                cleanBeforeSending={(oldData) => {
                    oldData.grantedBy = user?.id
                    oldData.type = 'manual'
                    if (customer) {
                        oldData.customer = customer.id
                    }
                    delete oldData.grantedByName

                    return oldData
                }}
                invalidate={customer ? ['getCustomerGiftCards'] : ['getGiftCards']}
            >
                <FormBlock formTemplate={formTemplate} />
            </FormWrap>
        </PageWrap>
    )
}

export default CreateGiftCard
